import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PontoFisicoService } from './ponto-fisico.service';
import { NgxPaginationModule } from 'ngx-pagination';
import { PipesModule } from '../comum/filtros/pipes/pipes.module';
import { ComumModule } from '../comum/comum.module';
import { routing } from '../rotas';
import { CadastroPontoFisicoComponent } from './cadastro-ponto-fisico/cadastro-ponto-fisico.component';
import { ListarPontoFisicoComponent } from './listar-ponto-fisico/listar-ponto-fisico.component';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TextMaskModule } from 'angular2-text-mask';
import { LoadingModule, ANIMATION_TYPES } from 'ngx-loading';
import { CadastroTipoPontoFisicoComponent } from './cadastro-tipo-ponto-fisico/cadastro-tipo-ponto-fisico.component';
import { ModalTipoPontoFisicoComponent } from './modal-tipo-ponto-fisico/modal-tipo-ponto-fisico.component';
import { ConfirmDialogModule, ConfirmationService } from 'primeng/primeng';
import { CookieService } from 'angular2-cookie/services/cookies.service';

@NgModule({
  imports: [
    CommonModule,
    NgxPaginationModule,
    NgbModule,
    PipesModule,
    ComumModule,
    routing,
    FormsModule,
    TextMaskModule,
    LoadingModule.forRoot({
      animationType: ANIMATION_TYPES.circle
    }),
    ConfirmDialogModule
  ],
  declarations: [ListarPontoFisicoComponent, CadastroPontoFisicoComponent, CadastroTipoPontoFisicoComponent,
    ModalTipoPontoFisicoComponent],
  exports: [ListarPontoFisicoComponent, CadastroPontoFisicoComponent, CadastroTipoPontoFisicoComponent,
    ModalTipoPontoFisicoComponent],
  providers: [PontoFisicoService, ConfirmationService, CookieService]
})
export class PontoFisicoModule { }



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/ponto-fisico/ponto-fisico.module.ts